import { memo, useEffect, useRef } from 'react';
import styled from 'styled-components';
import TeaseNotification from './TeaseNotification';
import useGetPlaySound from './useGetPlaySound';
import useRegisterRealTimeNotificationsCallbacks from '../../hooks/useRegisterRealTimeNotificationsCallbacks';
import { teaseNotificationsComponentDef } from 'navigation-components/config';
import { useDispatch } from 'react-redux';
import { setTeaseIframeDimensions } from '../../actions/IframeActions';
import usePrimaryTabTracker from '../../hooks/usePrimaryTabTracker';
import { NavMarker } from 'react-rhumb';
import ErrorBoundary from '../../components/ErrorBoundary';
import useUpdateIframeDimensionsOnResize from '../../hooks/useUpdateIframeDimensionsOnResize';
import { BrowserNotificationsRealtime } from '../../components/BrowserNotifications/BrowserNotificationsRealtime';
import { useNotificationsWithAlerts } from './hooks/useNotificationsWithAlerts';
import { isNotification } from '../../utils/IsNotification';
import TeaseAlert from './TeaseAlert';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTeaseNotificationContainer = styled.div.withConfig({
  displayName: "TeaseNotificationContainer__StyledTeaseNotificationContainer",
  componentId: "sc-1g3gai5-0"
})(["position:absolute;right:24px;display:flex;flex-direction:column;align-items:center;"]);
const TeaseNotificationContainer = /*#__PURE__*/memo(() => {
  useRegisterRealTimeNotificationsCallbacks(teaseNotificationsComponentDef);
  usePrimaryTabTracker(teaseNotificationsComponentDef);
  const dispatch = useDispatch();
  const teaseOrAlerts = useNotificationsWithAlerts();
  const getPlaySound = useGetPlaySound();
  const containerRef = useRef(null);
  const containerDimensions = useUpdateIframeDimensionsOnResize({
    containerRef,
    additionalHeightAdjustment: 36,
    additionalWidthAdjustment: 45
  });
  useEffect(() => {
    dispatch(setTeaseIframeDimensions(containerDimensions));
  }, [containerDimensions, dispatch]);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "TEASE_NOTIFICATIONS_ERROR",
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "TEASE_NOTIFICATIONS_LOAD"
      }), /*#__PURE__*/_jsx(StyledTeaseNotificationContainer, {
        "data-test-id": "tease-notifications-container",
        ref: containerRef,
        children: teaseOrAlerts.map(notificationOrAlert => {
          if (isNotification(notificationOrAlert)) {
            const notification = notificationOrAlert;
            const [playSound, soundDuration] = getPlaySound(notification.notificationSound);
            return /*#__PURE__*/_jsx(TeaseNotification, {
              notification: notification,
              playSound: playSound,
              soundDuration: soundDuration
            }, notification.id);
          }
          return /*#__PURE__*/_jsx(TeaseAlert, {
            alert: notificationOrAlert
          }, `alert-${notificationOrAlert.id}-${notificationOrAlert.kind}`);
        })
      }), /*#__PURE__*/_jsx(BrowserNotificationsRealtime, {})]
    })
  });
});
export default TeaseNotificationContainer;